import { z } from "zod";

/**
 * CopiaFolhaPagamentoSchema
 */

export const CopiaFolhaPagamentoSchema = z.object({
  descricao: z.string({ required_error: 'É necessário preencher este campo!' }),
  dataCadastro: z.coerce.date({ required_error: 'É necessário preencher este campo!' }),
  dataPagamento: z.coerce.date({ required_error: 'É necessário preencher este campo!' }),
});

/**
 * CopiaFolhaPagamentoForm
 */

export type CopiaFolhaPagamentoForm = z.infer<typeof CopiaFolhaPagamentoSchema>;